export default __webpack_public_path__ + "static/media/snipping-loading2.ece48b52.gif";